import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { regionData } from "element-china-area-data";
import axios from "axios";
import global from "../global";
import CryptoJS from "crypto-js";


import { ElLoading } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/loading/style/css';
/** 分段 / 总 mounted 耗时超过该毫秒数才打印，减少日志量 */
const SLOW_STEP_LOG_MS = 500;
export default {
  data() {
    return {
      institution: sessionStorage.getItem("institution"),
      zoom: sessionStorage.getItem("zoom"),
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      courseTypeOptions: [],
      showPage: 0,
      showAddCampus: false,
      showAddClassroom: false,
      //创建校区相关变量
      ifReserved: true,
      reservedTime: "",
      campusName: "",
      campusAddress: "",
      campusPhone: "",
      campusPhoneValidate: false,
      //选择省市区相关变量
      regionData: regionData,
      selectedProvince: "",
      selectedCity: "",
      selectedArea: "",
      provinces: [],
      cities: [],
      areas: [],
      //创建教室相关变量
      campusId: 2,
      classroomId: 0,
      classroomName: "",
      classroomCapacity: "",
      //选择教室的设备
      classroomEquipmentsStr: "",
      classroomEquipments: [],
      classroomEquipmentsIndex: [],
      classroomEquipmentsOptions: [],
      //添加设备
      showAddDevice: false,
      addDeviceName: "",
      //编辑教室信息
      showEditClassroom: false,
      //停用教室
      showDeactivateClassroom: false,
      // 校区列表
      campusList: JSON.parse(sessionStorage.getItem("campusList")),
      selectedCampusIndex: 0,
      selectedCampusId: 0,
      campusNames: {},
      // 校区信息
      isCampusInfoEditable: false,
      // 停用校区
      showDeactivateCampus: false,
      showDeactivateCampusMessage: "",
      // 重置密码弹窗
      showResetPassword: false,
      newPassword: "",
      confirmNewPassword: ""
    };
  },
  async mounted() {
    const mountT0 = performance.now();
    let stepT0 = mountT0;
    // 记录每个步骤的用时（仅慢步骤打印）
    const logStep = label => {
      const t = performance.now();
      const dt = t - stepT0;
      if (dt > SLOW_STEP_LOG_MS) {
        console.log(`[campus mounted] ${label}: ${dt.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
      }
      stepT0 = t;
    };
    console.log("\nEnter page /campus");

    // 如果是老用户，重置密码弹窗
    if (!this.userInfo.isNewUser) {
      this.showResetPassword = true;
    }
    logStep("老用户重置密码弹窗判断");

    // 给APP.vue传值
    // this.updateVariable({
    //   institution: this.institution,
    //   userInfo: this.userInfo,
    // });

    // 改到login中调用
    // 调用App.vue 的 updateVariable函数
    // <router-view>中加 @updateVariable="updateVariable"
    // this.$emit("updateVariable");

    // 显示菜单栏
    document.getElementById("menu").style.display = "block";
    document.getElementById("showAfterLogin").style.display = "block";
    logStep("显示菜单栏 DOM");

    //获取校区
    if (!this.campusList) {
      await this.queryCampus();
    }
    logStep("获取校区 queryCampus（含已缓存跳过）");
    for (let i = 0; i < this.campusList.length; i++) {
      this.campusNames[this.campusList[i].campus.id] = this.campusList[i].campus.name;
    }
    if (this.campusList.length > 0) {
      this.selectedCampusId = this.campusList[this.selectedCampusIndex].campus.id;
    }
    logStep("campusNames 与默认选中校区");
    // console.log("this.campusList:", this.campusList);

    //获取设备清单
    await this.getEquipmentsOptions();
    logStep("获取设备清单 getEquipmentsOptions");

    // 初始化省份数据
    this.provinces = this.regionData;
    logStep("初始化省份 regionData");
    // 查看原始数组数据
    // console.log("原始数据:", this.regionData);
    // 查看第一个元素 {value: '11', label: '北京市', children: Array(1)}
    // console.log("第一个省份:", this.regionData[0]);

    // 如果有校区，直接显示教室列表页面
    if (this.campusList.length > 0) {
      //默认选择第一个校区
      this.selectedCampusIndex = 0;
      this.campusId = this.campusList[this.selectedCampusIndex].campus.id;
      this.campusName = this.campusList[this.selectedCampusIndex].campus.name;
      this.campusAddress = this.campusList[this.selectedCampusIndex].campus.address;
      this.campusPhone = this.campusList[this.selectedCampusIndex].campus.phone;
      this.selectedProvince = this.campusList[this.selectedCampusIndex].campus.province;
      this.onProvinceChange();
      this.selectedCity = this.campusList[this.selectedCampusIndex].campus.city;
      this.onCityChange();
      this.selectedArea = this.campusList[this.selectedCampusIndex].campus.area;

      // console.log(
      //   "教室列表:",
      //   this.campusList[this.selectedCampusIndex].classrooms
      // );

      //显示教室列表页面
      this.showPage = 4;
      logStep("有校区：省市区联动与 showPage=4");
    }
    // 如果没有校区，显示创建校区页面
    else {
      this.showPage = 1;
      logStep("无校区：showPage=1");
    }
    const dtMountAll = performance.now() - mountT0;
    if (dtMountAll > SLOW_STEP_LOG_MS) {
      console.log(`[campus mounted] 总用时: ${dtMountAll.toFixed(1)}ms (>${SLOW_STEP_LOG_MS}ms)`);
    }
  },
  methods: {
    async resetPasswordConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.newPassword == "" || this.confirmNewPassword == "") {
          alert("请填写所有输入框");
          return;
        }
        if (this.newPassword !== this.confirmNewPassword) {
          alert("两次输入的新密码不一致");
          return;
        }

        // 原密码加密
        let encryptedPassword = this.userInfo.password;

        // 新密码加密
        let newEncryptedPassword = CryptoJS.AES.encrypt(this.newPassword, global.keyArray.join("") // 将数组转换为字符串作为密钥
        ).toString();

        // 更新密码
        let params = {
          formerPassword: encryptedPassword,
          phone: this.userInfo.phone,
          password: newEncryptedPassword,
          flag: "firstReset"
        };
        let resp1 = await axios.post("https://backend.wonology.com/login/modifyPassword", params);
        if (resp1.data.code == "0000") {
          this.$message({
            message: "修改密码成功",
            type: "success"
          });
          this.userInfo.isNewUser = 1;
          sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          this.showResetPassword = false;
        } else {
          console.error("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.error("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    resetPasswordCancel() {
      this.showResetPassword = false;
    },
    // 查询校区
    async queryCampus() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/queryCampus", params);
        if (resp1.data.code == "0000") {
          console.log("获取校区:", resp1.data.data);
          this.campusList = resp1.data.data;
          sessionStorage.setItem("campusList", JSON.stringify(resp1.data.data));
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error: " + error);
      } finally {
        loading.close();
      }
    },
    // 获取设备清单
    async getEquipmentsOptions() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          institution: this.institution
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/queryEquipments", params);
        if (resp1.data.code == "0000") {
          // 如果有数据
          if (resp1.data.data.length > 0) {
            // 教室设备
            this.classroomEquipmentsOptions = [];
            if (resp1.data.data[0].equipments) {
              this.classroomEquipmentsOptions = JSON.parse(resp1.data.data[0].equipments);
            }

            // 班级类型
            this.courseTypeOptions = [];
            if (resp1.data.data[0].courseType) {
              this.courseTypeOptions = JSON.parse(resp1.data.data[0].courseType);
            }

            // console.log("this.courseTypeOptions:", this.courseTypeOptions);

            sessionStorage.setItem("courseTypeOptions", JSON.stringify(this.courseTypeOptions));
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    ////////////////////////////////
    // 创建校区 按钮
    createCampus() {
      //重置校区信息
      this.campusName = "";
      this.selectedProvince = "";
      this.selectedCity = "";
      this.selectedArea = "";
      this.campusAddress = "";
      this.campusPhone = "";
      this.showPage = 2;
      if (this.provinces.length == 0) {
        // 初始化省份数据
        this.provinces = this.regionData;
        // 查看原始数组数据
        // console.log("原始数据:", this.regionData);
        // 查看第一个元素
        // {value: '11', label: '北京市', children: Array(1)}
        console.log("第一个省份:", this.regionData[0]);
      }
    },
    // 添加校区 按钮
    addCampus() {
      //重置校区信息
      this.campusName = "";
      this.selectedProvince = "";
      this.selectedCity = "";
      this.selectedArea = "";
      this.campusAddress = "";
      this.campusPhone = "";
      this.showAddCampus = true;
      if (this.provinces.length == 0) {
        // 初始化省份数据
        this.provinces = this.regionData;
        // 查看原始数组数据
        // console.log("原始数据:", this.regionData);
        // 查看第一个元素
        // {value: '11', label: '北京市', children: Array(1)}
        console.log("第一个省份:", this.regionData[0]);
      }
    },
    // 选择跑校区预留时间
    selectIfReserved() {
      console.log("this.ifReserved:", this.ifReserved);
    },
    onProvinceChange() {
      this.selectedCity = "";
      this.selectedArea = "";
      this.cities = [];
      this.areas = [];

      // console.log("选中的省份:", this.selectedProvince);

      if (this.selectedProvince) {
        // 找出选中的省份
        const province = this.regionData.find(p => p.label === this.selectedProvince);
        // 获取该省份的市
        if (province) {
          this.cities = province.children;
        }
      }

      // console.log("第一个市:", this.cities[0]);
    },
    onCityChange() {
      this.selectedArea = "";
      this.areas = [];
      if (this.selectedCity) {
        // 找出选中的市
        const city = this.cities.find(c => c.label === this.selectedCity);
        // 获取该市的区
        if (city) {
          this.areas = city.children || [];
        }
      }
    },
    // 校验座机号或手机号
    validatePhone() {
      const phone = this.campusPhone;

      // 手机号正则表达式 (11位数字，以1开头, 第二个必须是3-9，剩下9个数字)
      const mobileRegex = /^1[3-9]\d{9}$/;
      // 座机号正则表达式 (区号-号码（7到8位）-分机号格式) (\d{3,4}-)? 指可以不要
      const landlineRegex = /^\d{3,4}-\d{7,8}(-\d{1,6})?$/;
      if (!mobileRegex.test(phone) && !landlineRegex.test(phone)) {
        this.campusPhoneValidate = false;
        alert("请输入正确的手机号或座机号");
        return false;
      }
      this.campusPhoneValidate = true;
      return true;
    },
    // 添加校区
    async confirmAddCampus() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (!this.campusPhoneValidate) {
          alert("请填写正确的校区电话");
          return;
        }
        // if (this.ifReserved && !this.reservedTime) {
        //   alert("请输入老师跑校区预留时间");

        //   return;
        // }

        if (this.campusName && this.selectedProvince && this.selectedCity && this.selectedArea && this.campusAddress && this.campusPhone) {
          let params = {
            institution: this.institution,
            reservedTime: this.reservedTime,
            campusName: this.campusName,
            selectedProvince: this.selectedProvince,
            selectedCity: this.selectedCity,
            selectedArea: this.selectedArea,
            campusAddress: this.campusAddress,
            campusPhone: this.campusPhone
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/createCampus", params);
          if (resp1.data.code == "0000") {
            this.campusId = resp1.data.data.insertId; // 获取新创建的校区ID

            // 如果是增加校区，则关闭弹窗
            if (this.showAddCampus) {
              this.showAddCampus = false;
              await this.queryCampus();
            }
            // 如果是创建校区，则下一步
            else {
              this.showPage = 3;
            }
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } else {
          alert("请填写完整的校区信息");
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    addCampusCancel() {
      // 取消添加校区，还原当前校区信息
      // this.clickCampus(this.selectedCampusIndex);
      this.handleCampusChange();
      this.showAddCampus = false;
    },
    ////////////////////////////////
    // 创建教室相关函数
    // 选择设备
    clickDevice(index) {
      //如果已选中的设备，再次点击就是取消选中
      if (this.classroomEquipmentsIndex.includes(index)) {
        this.classroomEquipmentsIndex.splice(this.classroomEquipmentsIndex.indexOf(index), 1);
        this.classroomEquipments.splice(this.classroomEquipments.indexOf(index), 1);
      } else {
        this.classroomEquipmentsIndex.push(index);
        this.classroomEquipments.push(this.classroomEquipmentsOptions[index]);
      }
      console.log("this.classroomEquipmentsIndex:", this.classroomEquipmentsIndex);
      this.classroomEquipmentsStr = this.classroomEquipments.join("、");
    },
    //创建教室
    async confirmAddClassroom() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.campusId && this.classroomName && this.classroomCapacity && this.classroomEquipmentsStr) {
          let params = {
            campusId: this.campusId,
            classroomName: this.classroomName,
            classroomCapacity: this.classroomCapacity,
            classroomEquipmentsStr: this.classroomEquipmentsStr
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/createClassroom", params);
          if (resp1.data.code == "0000") {
            await this.queryCampus(); // 重新获取校区列表

            this.selectedCampusIndex = 0;
            this.selectedCampusId = this.campusList[this.selectedCampusIndex].campusId;
            this.showPage = 4;
            this.showAddClassroom = false;
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } else {
          alert("请填写完整的教室信息");
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //增加设备
    addDevice() {
      this.showAddDevice = true;
    },
    async addDeviceConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.classroomEquipmentsOptions.includes(this.addDeviceName)) {
          alert("设备已存在");
          return;
        } else {
          if (this.addDeviceName == "" || this.addDeviceName == null) {
            alert("请输入设备名称");
            return;
          }
          try {
            let params = {
              deviceName: this.addDeviceName,
              institution: this.institution
            };
            let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/addEquipment", params);
            if (resp1.data.code == "0000") {
              this.classroomEquipmentsOptions.push(this.addDeviceName);
              this.addDeviceName = "";
              this.showAddDevice = false;
            } else {
              console.log("调用后端出错:", resp1.data.msg);
              alert("调用后端出错: " + resp1.data.msg);
            }
          } catch (error) {
            console.log("catch error:", error);
            alert("catch error");
          } finally {
            loading.close();
          }
        }
      } finally {
        loading.close();
      }
    },
    addDeviceCancel() {
      this.showAddDevice = false;
    },
    ///////////////////////////////
    // 教室列表相关函数
    // 新增教室
    addClassroom() {
      this.showEditClassroom = false;
      this.showAddClassroom = true;

      // 重置教室相关变量
      this.classroomName = "";
      this.classroomCapacity = "";
      this.classroomEquipmentsStr = "";
      this.classroomEquipments = [];
      this.classroomEquipmentsIndex = [];
    },
    addClassroomCancel() {
      this.showAddClassroom = false;
    },
    //查询是否能停用教室
    async deactiveClassroom(classroomId) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          classroomId: classroomId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/ifCanDeactivateClassroom", params);
        if (resp1.data.code == "0000") {
          //如果可以停用教室，直接调用
          if (resp1.data.data == 1) {
            await this.confirmDeactiveClassroom(classroomId);
          }
          //如果不可以停用教室，提示 弹窗
          if (resp1.data.data == 0) {
            this.showDeactivateClassroom = true;
          }
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    //停用教室
    async confirmDeactiveClassroom(classroomId) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          classroomId: classroomId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/deactivateClassroom", params);
        if (resp1.data.code == "0000") {
          this.campusList[this.selectedCampusIndex].classrooms.forEach(item => {
            if (item.id === classroomId) {
              item.isActive = 0; // 更新状态为停用
            }
          });
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    deactivateClassroomCancel() {
      this.showDeactivateClassroom = false;
    },
    async activeClassroom(classroomId) {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        let params = {
          classroomId: classroomId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/activateClassroom", params);
        if (resp1.data.code == "0000") {
          this.campusList[this.selectedCampusIndex].classrooms.forEach(item => {
            if (item.id === classroomId) {
              item.isActive = 1; // 更新状态为启用
            }
          });
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    // 编辑教室信息
    editClassroom(index) {
      this.classroomId = this.campusList[this.selectedCampusIndex].classrooms[index].id;
      this.classroomName = this.campusList[this.selectedCampusIndex].classrooms[index].name;
      this.classroomCapacity = this.campusList[this.selectedCampusIndex].classrooms[index].capacity;
      this.classroomEquipmentsStr = this.campusList[this.selectedCampusIndex].classrooms[index].equipmentStr;

      //找出各个设备的索引
      this.classroomEquipments = this.classroomEquipmentsStr.split("、");
      this.classroomEquipmentsIndex = [];
      for (let i in this.classroomEquipments) {
        for (let j in this.classroomEquipmentsOptions) {
          if (this.classroomEquipments[i] == this.classroomEquipmentsOptions[j]) {
            j = parseInt(j);
            if (this.classroomEquipmentsIndex.includes(j)) {
              continue;
            }
            this.classroomEquipmentsIndex.push(j);
            break;
          }
        }
      }
      console.log("this.classroomEquipments:", this.classroomEquipments);
      console.log("this.classroomEquipmentsIndex:", this.classroomEquipmentsIndex);

      //修改教室信息
      this.showEditClassroom = true;
      //创建教室弹窗
      this.showAddClassroom = true;
    },
    // 确认修改教室信息
    async saveClassroom() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.classroomId && this.classroomName && this.classroomCapacity && this.classroomEquipmentsStr) {
          let params = {
            campusId: this.campusId,
            classroomId: this.classroomId,
            classroomName: this.classroomName,
            classroomCapacity: this.classroomCapacity,
            classroomEquipmentsStr: this.classroomEquipmentsStr
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/editClassroom", params);
          if (resp1.data.code == "0000") {
            await this.queryCampus();
            this.showAddClassroom = false;
            this.showEditClassroom = false;
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } else {
          alert("请填写完整的教室信息");
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    editClassroomCancel() {
      this.showPage = 4;
    },
    ///////////////////////////////
    // 校区 相关函数
    // 点击校区下拉框，展开下拉菜单
    clickCampusSelect() {
      // 通过 this.$refs 获取 el-select 实例
      const select = this.$refs.campusSelectRef;
      if (select) {
        // 先聚焦（可选，但推荐）
        select.focus();
        // 调用 toggleMenu 展开/收起下拉菜单
        select.toggleMenu();
      }
    },
    // 选择校区
    handleCampusChange() {
      // console.log("选择的校区:", this.selectedCampusId);

      this.selectedCampusIndex = this.campusList.findIndex(campus => campus.campus.id === this.selectedCampusId);

      // 更新校区信息
      this.campusId = this.campusList[this.selectedCampusIndex].campus.id;
      this.campusName = this.campusList[this.selectedCampusIndex].campus.name;
      this.campusAddress = this.campusList[this.selectedCampusIndex].campus.address;
      this.campusPhone = this.campusList[this.selectedCampusIndex].campus.phone;
      this.selectedProvince = this.campusList[this.selectedCampusIndex].campus.province;
      this.onProvinceChange();
      this.selectedCity = this.campusList[this.selectedCampusIndex].campus.city;
      this.onCityChange();
      this.selectedArea = this.campusList[this.selectedCampusIndex].campus.area;
    },
    //切换校区, 点击校区时自动滚动到可视区域
    clickCampus(index) {
      this.selectedCampusIndex = index;

      // 切换校区，更新校区信息
      this.campusId = this.campusList[this.selectedCampusIndex].campus.id;
      this.campusName = this.campusList[this.selectedCampusIndex].campus.name;
      this.campusAddress = this.campusList[this.selectedCampusIndex].campus.address;
      this.campusPhone = this.campusList[this.selectedCampusIndex].campus.phone;
      this.selectedProvince = this.campusList[this.selectedCampusIndex].campus.province;
      this.onProvinceChange();
      this.selectedCity = this.campusList[this.selectedCampusIndex].campus.city;
      console.log("this.selectedCity:", this.selectedCity);
      this.onCityChange();
      this.selectedArea = this.campusList[this.selectedCampusIndex].campus.area;

      // 点击校区时自动滚动到可视区域
      // 在下一个DOM更新周期执行滚动操作
      this.$nextTick(() => {
        console.log("点击校区:", index);

        //校区列表
        const container = document.getElementById("campusListContainer");
        // console.log("container:", container);
        // 获取选中的校区元素
        const selectedElement = container.children[index].children[0];
        // console.log("selectedElement:", selectedElement);

        if (container && selectedElement) {
          // 计算选中元素相对于容器的位置 (这些数值是乘了zoom的)
          const containerRect = container.getBoundingClientRect();
          // console.log("containerRect:", containerRect);
          const elementRect = selectedElement.getBoundingClientRect();
          // console.log("elementRect:", elementRect);

          // 计算元素在容器中的位置
          // scrollLeft, offsetWidth, clientWidth这些获取的都是原始尺寸,要乘zoom
          const elementLeft = elementRect.left - containerRect.left + container.scrollLeft * this.zoom;
          const elementRight = elementLeft + selectedElement.offsetWidth * this.zoom;

          // console.log("元素在容器中的位置:", elementLeft, elementRight);
          // console.log("container.scrollLeft:", container.scrollLeft);

          // 如果元素在可视区域左侧外
          if (elementLeft < container.scrollLeft * this.zoom) {
            container.scrollTo({
              left: elementLeft / this.zoom,
              behavior: "smooth"
            });
          }
          // 如果元素在可视区域右侧外
          else if (elementRight > (container.scrollLeft + container.clientWidth) * this.zoom) {
            container.scrollTo({
              left: (elementRight - container.clientWidth * this.zoom) / this.zoom,
              behavior: "smooth"
            });
          }

          // console.log("container.scrollLeft:", container.scrollLeft);
        }
      });
    },
    // 鼠标滚轮控制 校区列表的 横向滚动
    handleWheel(event) {
      // console.log("鼠标滚轮事件:", event);
      const container = document.getElementById("campusListContainer");
      container.scrollLeft += event.deltaY;
      console.log("container.scrollLeft:", container.scrollLeft);
    },
    //编辑校区信息
    editCampus() {
      this.isCampusInfoEditable = true;
    },
    //保存校区信息
    async saveCampus() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        if (this.campusName && this.selectedProvince && this.selectedCity && this.selectedArea && this.campusAddress && this.campusPhone) {
          let params = {
            institution: this.institution,
            campusId: this.campusId,
            campusName: this.campusName,
            selectedProvince: this.selectedProvince,
            selectedCity: this.selectedCity,
            selectedArea: this.selectedArea,
            campusAddress: this.campusAddress,
            campusPhone: this.campusPhone
          };
          let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/editCampus", params);
          if (resp1.data.code == "0000") {
            await this.queryCampus();
            this.isCampusInfoEditable = false;
          } else {
            console.log("调用后端出错:", resp1.data.msg);
            alert("调用后端出错: " + resp1.data.msg);
          }
        } else {
          alert("请填写完整的校区信息");
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    async cancelEditCampus() {
      //如果取消编辑，还原数据
      // await this.queryCampus()
      // this.clickCampus(this.selectedCampusIndex);
      this.handleCampusChange();
      this.isCampusInfoEditable = false;
    },
    //停用校区时 查询是否可以停用
    async deactivateCampus() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        //查询是否可以停用校区
        let params = {
          campusId: this.campusId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/ifCanDeactivateCampus", params);
        if (resp1.data.code == "0000") {
          //不可以停用校区，提示 弹窗
          if (resp1.data.data == 0) {
            this.showDeactivateCampusMessage = "该校区今天及以后还有安排的课程，停用后会自动删除后面所有的课程！是否确认停用？";
            // this.showDeactivateCampusMessage =
            //   "该校区今天及以后还有安排的课程，请把该校区的课程清空，再停用校区";
          }
          //可以停用校区，确认 弹窗
          if (resp1.data.data == 1) {
            this.showDeactivateCampusMessage = "确认是否停用校区？";
          }
          this.showDeactivateCampus = true;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    async deactivateCampusConfirm() {
      //loading界面
      const loading = ElLoading.service({
        lock: true,
        text: "处理中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        //停用校区
        let params = {
          campusId: this.campusId
        };
        let resp1 = await axios.post("https://backend.wonology.com/courseArrange/campus/deactivateCampus", params);
        if (resp1.data.code == "0000") {
          // 从校区列表中移除停用的校区
          this.campusList = this.campusList.filter(item => item.campus.id !== this.campusId);

          // 如果当前选中的校区被停用，重置选中索引
          // if (this.selectedCampusIndex >= this.campusList.length) {
          //   // this.selectedCampusIndex = 0;
          //   await this.clickCampus(0);
          // }

          //重置选中的校区
          // await this.clickCampus(0);
          this.selectedCampusId = this.campusList[0].id;
          this.handleCampusChange();
          this.showDeactivateCampus = false;
        } else {
          console.log("调用后端出错:", resp1.data.msg);
          alert("调用后端出错: " + resp1.data.msg);
        }
      } catch (error) {
        console.log("catch error:", error);
        alert("catch error");
      } finally {
        loading.close();
      }
    },
    deactivateCampusCancel() {
      this.showDeactivateCampus = false;
    }
  }
};